'use strict';

/**
 * For browser compatibility, we can just use the existing `XMLHttpRequest`.
 */
module.exports = window.XMLHttpRequest;




// WEBPACK FOOTER //
// ./node_modules/node-http-xhr/lib/browser.js